export const templateList = [
    {name:'TemplateTimer',title:'Counter'},
    {name:'TemplateProducts', title: 'Products'},
    {name: 'TemplateTabs', title: 'Tabs'}
];